<template>
  <div class="dashboard">
    <div class="dashboard-inner">
      <div class="row">
        <!-- 智能批改 -->
        <div class="col" v-if="$query.debug || auth.zuoye">
          <a class="block block-dark block-green" target="_blank"
             :href="getUrl({ domain: zuoye })">
            <div class="block-icon">
              <img :src="require('/src/assets/img/日常考试@3x.png')">
            </div>
            <div>
              <div class="huge title">智能批改助手</div>
              <div>{{auth.zuoye ? '布置新考试' : '未开通'}}</div>
            </div>
          </a>
        </div>
        <!--听说突破-->
        <div class="col" v-if="$query.debug || auth.speak">
          <a class="block block-dark block-dark-blue2" target="_blank"
             :href="english && getUrl({ domain: speak })"
             @click="alertEnglish(english, '听说突破')">
            <div class="block-icon">
              <img :src="require('/src/assets/img/听说@2x.png')">
            </div>
            <div>
              <div class="huge title">听说突破</div>
              <div>{{auth.speak ? '布置新作业' : '未开通'}}</div>
            </div>
          </a>
        </div>
        <!-- 分级阅读 -->
        <div class="col" v-if="$query.debug || auth.reading">
          <a class="block block-dark block-blue" target="_blank"
             :href="english && getUrl({ domain: reading })"
             @click="alertEnglish(english, '分级阅读')">
            <div class="block-icon">
              <img :src="require('/src/assets/img/联考平台@3x.png')"
                   style="transform: translateY(10px)">
            </div>
            <div>
              <div class="huge title">分级阅读</div>
              <div>{{auth.reading ? '布置新作业' : '未开通'}}</div>
            </div>
          </a>
        </div>
        <!-- 词汇满分 -->
        <div class="col" v-if="$query.debug || auth.words">
          <a class="block block-dark block-light-green" target="_blank"
             :href="english && getUrl({ domain: words })"
             @click="alertEnglish(english, '词汇满分')">
            <div class="block-icon block-icon-large">
              <img :src="require('/src/assets/img/单词@3x.png')">
            </div>
            <div>
              <div class="huge title">词汇满分</div>
              <div>{{auth.words ? '布置新练习' : '未开通'}}</div>
            </div>
          </a>
        </div>
        <!-- 学情分析 -->
        <div class="col" v-if="$query.debug || auth.situation">
          <a class="block block-dark block-light-yellow" target="_blank"
             :href="getUrl({ domain: zuoye, redirect: '/#/situation/trend' })">
            <div class="block-icon block-icon-large">
              <img :src="require('/src/assets/img/学情分析.png')">
            </div>
            <div>
              <div class="huge title">学情分析</div>
              <div>{{auth.situation ? '进入' : '未开通'}}</div>
            </div>
          </a>
        </div>
        <!-- 校本题库 -->
        <div class="col" v-if="$query.debug || auth.tiku">
          <a class="block block-dark block-dark-blue" target="_blank"
             :href="getUrl({ domain: tiku, path: '/api/school_repository/user/inject'})">
            <div class="block-icon block-icon-large">
              <img :src="require('/src/assets/img/校本题库.png')">
            </div>
            <div>
              <div class="huge title">校本题库</div>
              <div>{{auth.tiku ? '进入' : '未开通'}}</div>
            </div>
          </a>
        </div>
        <!-- 新功能 -->
        <!-- <div class="col">
          <a class="block block-dark block-grey disabled" target="_blank">
            <div class="block-icon">
              <img :src="require('/src/assets/img/新功能@3x.png')">
            </div>
            <div>
              <div class="huge title">新功能敬请期待</div>
            </div>
          </a>
        </div> -->
      </div>
      <!-- 彩色块结束 -->
      <div class="row section-margin">
        <div class="col" v-if="$query.debug || auth.zuoye">
          <!--阅卷任务-->
          <a class="block block-white" target="_blank"
             :href="getUrl({ domain: zuoye, redirect: '/#/marking/list' })">
            <div class="block-icon">
              <div class="icon icon-yuejuan"></div>
            </div>
            <div class="large m-t-15">
              阅卷任务
              <span class="color-gray" v-if="!auth.zuoye">(未开通)</span>
            </div>
          </a>
        </div>
        <!--班级管理-->
        <div class="col" v-if="!isAiDomain">
          <router-link class="block block-white" to="/group/list">
            <div class="block-icon">
              <div class="icon icon-banji"></div>
            </div>
            <div class="large m-t-15">
              班级管理
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _some from 'lodash/some'
import { stringify } from 'qs'

export default {
  data () {
    let data
    if (process.env.VUE_APP_ENV === 'PUBLISH' || process.env.VUE_APP_ENV === 'PRE') {
      data = {
        zuoye: 'pigai.hexinedu.com',
        words: 'words.hexinedu.com',
        tiku: 'tiku.hexinedu.com',
        reading: 'read.hexinedu.com',
        speak: 'speaking.hexinedu.com'
      }
    } else {
      data = {
        zuoye: 'zuoye.hexin.im',
        words: 'words.hexin.im',
        tiku: 'tiku.hexin.im',
        reading: 'reading.teacher.hexin.im',
        speak: 'speaking.hexin.im',
      }
    }
    return {
      url: '/api/user/domain/inject',
      ...data,
    }
  },
  methods: {
    getUrl ({ domain, redirect = '/', path }) {
      return `${this.url}?${stringify({ domain, redirect, path })}`
    },
    alertEnglish (auth, title) {
      if (!auth) {
        this.$message.warning(
          `非英语学科老师不能使用英语学科专属功能${title}。\n如需开通请联系客服：400-6683-698`)
      }
      return auth
    },
  },
  computed: {
    isAiDomain () {
      return /^https?:\/\/ai.hexinedu.com/.test(window.location.origin)
    },
    english () {
      return _some(this.$user.subject, s => s.en_name.indexOf('english') > -1)
    },
    auth () {
      return {
        zuoye: this.$user.funcs.zuoye,
        words: this.$user.funcs.words,
        reading: this.$user.funcs.reading,
        tiku: this.$user.funcs.tiku,
        speak: this.$user.funcs.speak,
        situation: this.$user.funcs.zuoye && this.$user.funcs.situation !== false,
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "src/styles/mixins";
@import "src/styles/vars";

.dashboard {
  position: relative;
  min-height: 100%;
  font-size: 1rem;

  .dashboard-inner {
    padding: 60px 0 80px;
  }
}

$gap: 20px;

.row {
  @include clearfix;
  margin-left: -$gap;
  margin-right: -$gap;
}

.col {
  float: left;
  width: 33.33%;
  padding-left: $gap;
  padding-right: $gap;
  margin-top: 20px;
}

.huge {
  font-size: 1.5rem;
}

.large {
  font-size: 1.15rem;
}

.color-gray {
  color: #888;
}

.section-margin {
  margin-top: 40px;
}

.block {
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  min-width: 160px;

  &.block-dark {
    padding: 50px 20px;
    color: white;
    background-image: url(../assets/img/背景贴图@3x.png);
    background-size: 100% 100%;
    justify-content: space-evenly;

    .title {
      font-weight: bold;
      margin-bottom: 10px;
    }

    img {
      height: 85px;
    }

    @media (max-width: 980px) {
      flex-direction: column;
      text-align: center;
      padding: 25px 0;
      .title {
        margin-bottom: 2px;
      }
      img {
        height: 60px;
        margin-bottom: 10px;
      }
    }
    @media (max-width: 768px) {
      flex-direction: row;
      > div {
        display: flex;
        flex: 3;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      > div:nth-child(2) {
        padding: 0 5%;
      }
      .block-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 50px;
        margin: 0;

        img {
          margin: 0;
        }
      }
    }
    @media (max-width: 424px) {
      .block-icon {
        height: 35px;

        img {
          height: 40px;
        }
      }
    }
  }

  &.disabled {
    cursor: default;
  }

  $colors: (
    'green': $color-green,
    'blue': $color-blue,
    'dark-blue': $color-dark-blue,
    'dark-blue2': #3299ff,
    'light-yellow': $color-light-yellow,
    'yellow': $color-yellow,
    'light-green': $color-light-green,
    'grey': $color-grey
  );
  @each $name, $color in $colors {
    &.block-dark.block-#{$name} {
      background-color: $color;

      &:hover:not(.disabled) {
        background-color: mix($color, black, 90%);
      }
    }
  }

  &.block-white {
    padding: 45px 0;
    flex-direction: column;
    color: $color-normal;
    border: 1px solid #CDDFE2;

    .icon {
      $size: 45px;
      width: $size;
      height: $size;
      background-size: cover;
      background-position: center;
    }

    .icon-yuejuan {
      background-image: url(../assets/img/01阅卷任务@3x.png);
    }

    .icon-banji {
      background-image: url(../assets/img/02班级管理@3x.png);
    }

    .icon-xueqing {
      background-image: url(../assets/img/03学情分析@3x.png);
    }

    &:hover {
      color: #11D0C4;
      border-color: #89e6e1;
      background-color: rgba(17, 208, 196, 0.06);

      .icon-yuejuan {
        background-image: url(../assets/img/01阅卷任务copy@3x.png);
      }

      .icon-banji {
        background-image: url(../assets/img/02班级管理copy@3x.png);
      }

      .icon-xueqing {
        background-image: url(../assets/img/03学情分析copy@3x.png);
      }
    }

    @media (max-width: 768px) {
      flex-direction: row;
      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 3;
      }
      > div:nth-child(2) {
        padding: 0 5%;
      }
      .block-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 50px;
        margin: 0;
      }
      .large {
        margin: 0;
      }
    }
    @media (max-width: 424px) {
      .icon {
        $size: 35px;
        width: $size;
        height: $size;
        background-size: cover;
        background-position: center;
      }
      .block-icon {
        height: 35px;
      }
    }
  }

  .block-icon.block-icon-large img {
    transform: scale(1.2);
    transform-origin: center;
  }
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

@media (max-width: 980px) {
  .huge {
    font-size: 1.3rem;
  }
  .section-margin {
    margin-top: 25px;
  }
}

@media screen and (max-width: 768px) {
  .dashboard {
    .dashboard-inner {
      padding: 30px 0;
    }
  }
  .row {
    margin: 0 0 20px 0;
  }
  .col {
    width: 100%;
    padding: 0;

    &:first-child {
      margin-top: 0;
    }
  }
  .block {
    &.block-dark,
    &.block-white {
      padding: 20px 20px 20px 0;
    }
  }
  .huge {
    margin: 0;
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 424px) {
  .block {
    &.block-dark,
    &.block-white {
      padding: 10px 10px 10px 0;
    }
  }
  body {
    font-size: 12px !important;
  }
  .huge,
  .large {
    font-size: 1rem;
  }
  .col {
    margin-top: 10px;
  }
}

</style>
